import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import {
  TABLE_ROW_HINT_INITIAL_STATE,
  TableRowHintState
} from '@store/table-store/table-row-hint.model.ts';

const useTableRowHintStore = create<TableRowHintState>()(
  devtools(
    persist(
      (set) => ({
        ...TABLE_ROW_HINT_INITIAL_STATE,

        markLearned: (tableKey) =>
          set((state) =>
            state.learnedTables[tableKey]
              ? state
              : { learnedTables: { ...state.learnedTables, [tableKey]: true } }
          )
      }),
      { name: 'table-row-hint-storage' }
    ),
    { name: 'TableRowHintStore' }
  )
);

export default useTableRowHintStore;
